function setFreeze() {
    $(".desktop-blur-cover").removeClass("hidden");

}
function releaseFreeze() {
    $(".desktop-blur-cover").addClass("hidden");

}

//keep the old popup status
if(localStorage.getItem("open") == "true") {
    $(".collection-filter").show();
    setFreeze();
} else {
    $(".collection-filter").hide();
}

$(document).ready(function() {

    //Sort the collection according sort menu
    $('#sort-by').on('change', function (e) {
        var valueSelected = this.value;
        var main_url = location.href.split("/?")[0]+"/?sort_by="+valueSelected;
        location.href = main_url;
    });
    $(document).on("click", "#show_filter", function(e) {
        e.preventDefault(); 
        if($(window).width() >= 990) {
            // if larger or equal
            setFreeze();
        }         

        $(".collection-filter").show("slide", { direction: "left" }, 500);  
        
        //flag for popup open status
        localStorage.setItem("open", "true");
    });
    $(document).on("click", ".filter-close-button", function() {
        if($(window).width() >= 990) {
            releaseFreeze();
        }       

        $(".collection-filter").hide("slide", { direction: "left" }, 500);
        //flag for popup open status
        localStorage.setItem("open", "false");
    });   

    $(document).on("click", ".desktop-blur-cover", function() {
        $(".collection-filter").hide();
        $(this).addClass("hidden");

    });

    //improve the filter speed with ajax
    $(document).on("click", ".collection-filter__tag a", function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        console.log(href)
        $.ajax({
          type:"GET",
          dataType: 'html',
          url: href,
          success: function(data){
       
            $(".collection__products-wrapper").html(($(data).find('.collection__products-wrapper').html()));
            $(".collection-filter").html(($(data).find('.collection-filter').html()));
              filterBar();
              slickslider();
              $(window).on('load resize orientationchange', function() {
                if ($(window).width() <= 700) {  
                  slickslider();
                } 
              });
          }
            
        });
    });
    
})